import React from 'react'

// Sets the page title while the component is mounted, and puts the previous
// one back when it unmounts.
export const useDocumentTitle = (title: string) => {
  React.useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
